import { render } from "./ModificationCard.vue?vue&type=template&id=6e4c9489&scoped=true"
import script from "./ModificationCard.vue?vue&type=script&lang=js"
export * from "./ModificationCard.vue?vue&type=script&lang=js"

import "./ModificationCard.vue?vue&type=style&index=0&id=6e4c9489&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4c9489"]])

export default __exports__